// extracted by mini-css-extract-plugin
module.exports = {"main":"About_main__1rWB0","left":"About_left__2QN4U","right":"About_right__3Zv1c","about":"About_about__1TzSR","rest":"About_rest__1e2fC"};